import { useMemo } from "react";
import { DataTableType } from "../types/index";
import { useLocalization } from "@/app/hook/use-localization";
import { useFormWatch, useForm } from "@/base/utils/index";

export function useDataTableHook<RecordType, FilterValueType>({
  columns,
  rowKey,
  actions,
  header,
  tableProps,
  searched = true,
  controller,
  emptyResult,
}: DataTableType<RecordType, FilterValueType>) {
  const localization = useLocalization();

  const [formTable] = useForm();

  useFormWatch(({ search }) => {
    controller.setSearch(search);
  }, formTable);

  const loading = useMemo(() => {
    return controller?.currentProcess?.status === "loading";
  }, [controller?.currentProcess]);

  return {
    columns,
    rowKey,
    formTable,
    actions,
    searched,
    emptyResult,
    tableProps,
    localization,
    loading,
    controller,
    header,
  };
}
